import React from 'react'
import { Link, useHistory } from 'react-router-dom'

import MetaTags from 'components/meta/MetaTags'
import ScrollTop from 'components/utils/ScrollTop'
import Container from 'components/layout/Container'
import LoginForm from './LoginForm'
import { Header, NavItem } from './styles'

const Login = () => {
  const history = useHistory()

  const handleResetPassword = () => {
    history.push('/reset-password')
  }

  const handleConfirmEmail = () => {
    history.push('/confirm-email')
  }

  return (
    <>
      <ScrollTop />
      <MetaTags title="Login" />

      <Container width={620} paddingY={40}>
        <Header>
          <ul>
            <NavItem active>
              <Link to="/login" className="qa-login-link">
                Login
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/signup" className="qa-sign-up-link">
                Sign up
              </Link>
            </NavItem>
          </ul>
        </Header>

        <LoginForm
          onConfirmEmail={handleConfirmEmail}
          onResetPassword={handleResetPassword}
          serverSide
        />
      </Container>
    </>
  )
}

export default Login
